export const aiCoursesRecommendations = {
  "recommendations": [
    {
      "university_name": "University of Warwick",
      "course_name": "MBA in Artificial Intelligence",
      "course_type": "MBA",
      "duration": "1 year",
      "tuition_fees": "£14,500",
      "living_costs": "£12,000/year",
      "location": "Coventry, UK",
      "recommendation_score": 92,
      "match_reasons": [
        "Matches your interest in MBA",
        "Fits your budget range",
        "Suitable for your experience level"
      ],
      "ai_courses_offered": [
        "AI Strategy",
        "Machine Learning for Business",
        "Data Analytics"
      ],
      "career_outcomes": {
        "average_salary": "£60,000",
        "employment_rate": "98%",
        "top_employers": [
          "Amazon",
          "Deloitte"
        ],
        "job_roles": [
          "AI Consultant",
          "Data Analyst"
        ]
      },
      "entry_requirements": {
        "academic_requirements": "Bachelor's degree with 2:1",
        "english_requirements": "IELTS 6.5",
        "work_experience": "3+ years required"
      },
      "course_structure": {
        "modules": [
          "AI in Business",
          "Strategic Management"
        ],
        "assessment_methods": [
          "Coursework",
          "Exams",
          "Project"
        ],
        "practical_components": "Yes"
      },
      "personalized_insights": {
        "strength_match": "High match for MBA interests",
        "budget_fit": "Excellent value for money",
        "career_alignment": "Strong alignment with your career goals"
      }
    },
    {
      "university_name": "University of Edinburgh",
      "course_name": "MBA with a focus on AI",
      "course_type": "MBA",
      "duration": "1 year",
      "tuition_fees": "£15,000",
      "living_costs": "£11,000/year",
      "location": "Edinburgh, UK",
      "recommendation_score": 89,
      "match_reasons": [
        "Matches your interest in MBA",
        "Fits your budget range",
        "Intermediate-level suitable"
      ],
      "ai_courses_offered": [
        "AI Ethics",
        "Data Science",
        "Business Intelligence"
      ],
      "career_outcomes": {
        "average_salary": "£58,000",
        "employment_rate": "96%",
        "top_employers": [
          "Facebook",
          "PwC"
        ],
        "job_roles": [
          "Business Analyst",
          "AI Strategist"
        ]
      },
      "entry_requirements": {
        "academic_requirements": "Bachelor's degree with 2:2",
        "english_requirements": "IELTS 6.5",
        "work_experience": "2+ years preferred"
      },
      "course_structure": {
        "modules": [
          "AI for Executives",
          "Leadership in AI"
        ],
        "assessment_methods": [
          "Coursework",
          "Exams"
        ],
        "practical_components": "Yes"
      },
      "personalized_insights": {
        "strength_match": "Good match for AI and business integration",
        "budget_fit": "Fit within budget",
        "career_alignment": "Aligned with career progression"
      }
    }
  ],
  "recommendation_summary": {
    "total_recommendations": 2,
    "interests": "MBA",
    "experience_level": "Intermediate",
    "budget_range": "£5k-£15k",
    "preferred_location": "UK",
    "top_recommendation": {
      "university": "University of Warwick",
      "course": "MBA in Artificial Intelligence",
      "score": 92,
      "reason": "High match for MBA interests, excellent career outcomes, and value for money"
    },
    "recommendation_breakdown": {
      "by_experience_level": {
        "beginner": 0,
        "intermediate": 2,
        "advanced": 0
      },
      "by_budget": {
        "low": 0,
        "medium": 2,
        "high": 0
      },
      "by_location": {
        "UK": 2,
        "USA": 0,
        "Other": 0
      }
    }
  },
  "career_guidance": {
    "career_paths": [
      {
        "path": "AI Consultant",
        "description": "Advising businesses on AI integration and strategy",
        "required_skills": [
          "AI Strategy",
          "Business Analysis"
        ],
        "salary_range": "£50,000 - £90,000"
      }
    ],
    "skill_development": [
      "Focus on strategic use of AI",
      "Develop leadership and management skills",
      "Engage in AI and business integration projects"
    ]
  },
  "context": {
    "title": "AI Course Recommendations",
    "summary": "These recommendations focus on MBA programs with a specialization in AI, aligning with interests, budget, and location preferences.",
    "methodology": "Courses were selected based on alignment with interests, budget constraints, and preferred location, focusing on reputable UK universities.",
    "insights": [
      "Strong emphasis on strategic AI management in MBA programs",
      "High alignment with career objectives in AI consultancy roles",
      "Skill development focuses on leadership in AI contexts"
    ],
    "citations": []
  },
  "tab_name": "ai-courses-recommendations",
  "evidence_sources": [
    {
      "source": "QS World University Rankings",
      "url": "https://www.topuniversities.com/university-rankings/business-masters-rankings/mba/2025",
      "title": "Top MBA Programs in UK 2025 - QS World University Rankings",
      "snippet": "QS World University Rankings for MBA programs in the UK 2025, featuring top institutions like Oxford, Cambridge, and London Business School with comprehensive program details.",
      "confidence": 0.8,
      "category": "course_recommendations",
      "content_domain": "Course Recommendations"
    },
    {
      "source": "Financial Times",
      "url": "https://rankings.ft.com/businessschoolrankings/global-mba-ranking-2025",
      "title": "Financial Times MBA Rankings 2025 - UK Business Schools",
      "snippet": "Financial Times annual MBA rankings 2025 including UK business schools with employment rates, salary data, and career outcomes for graduates.",
      "confidence": 0.8,
      "category": "course_recommendations",
      "content_domain": "Course Recommendations"
    }
  ],
  "cached": false,
  "timestamp": "2025-08-29T01:27:13.500032",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "ai_courses_recommendations",
    "interests": "MBA",
    "experience_level": "Intermediate",
    "budget_range": "£5k-£15k",
    "preferred_location": "UK",
    "total_recommendations": 2,
    "limit": 5,
    "response_time": 11.56,
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "ai_courses_recommendations_v1",
      "web_search_used": true
    }
  }
};
